import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { CloseOutlined } from '@ant-design/icons';
import './ContactPopover.css';

const ContactPopover = ({ onClose }) => {
  const [isExiting, setIsExiting] = useState(false);
  const [message, setMessage] = useState("");

  const handleClose = () => {
    setIsExiting(true);
  };

  useEffect(() => {
    if (isExiting) {
      const timer = setTimeout(() => {
        onClose();
      }, 300); 

      return () => clearTimeout(timer);
    }
  }, [isExiting, onClose]);

  const handleSend = () => {
    const recipientEmail = "aditya.gupta98528@gmail.com"; 
    const subject = "Message from your portfolio";
    
    const body = encodeURIComponent(message);
    
    const mailtoLink = `mailto:${recipientEmail}?subject=${encodeURIComponent(subject)}&body=${body}`;
    
    window.location.href = mailtoLink;
    
    handleClose();
  };

  return ReactDOM.createPortal(
    <div className={`contact-popover-overlay ${isExiting ? 'exiting' : ''}`}>
      <button className="popover-close-button" onClick={handleClose}>
        <CloseOutlined />
      </button>
      <div className="contact-popover-content">
        <div className="popover-top-section">
          <textarea
            className="popover-textarea"
            placeholder="Type your message..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>
        <div className="popover-bottom-section">
          <button className="popover-back-button" onClick={handleClose}>
            <span className="arrow-icon">←</span>go back
          </button>
          
          {message && (
             <button className="popover-send-button" onClick={handleSend}>
                send
             </button>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ContactPopover;
